import styled from "styled-components";

export const SearchParams = styled.div`
  display: flex;
  justify-content: space-between;
  .box {
    margin: 0 2rem 4.2rem 0;
  }
  h3 {
    ${({ theme }) => `
      color: ${theme.colors.blackTextTitle};
    `}
    font-size: 1.4rem;
    font-weight: 600;
  }
  .react-date-picker {
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 8px;
    border: none;
    box-shadow: 0px 5px 20px rgba(231, 231, 234, 0.62);
    box-sizing: border-box;
    font-size: 1.5rem;
    font-weight: 500;
    height: 5rem;
    padding-left: 1.5rem;
    padding-right: 1rem;
    width: 25.6rem;
  }

  .react-date-picker__wrapper {
    border: none;
  }

  .clickable-element {
    cursor: pointer;
  }
`;

export const LittleBox = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.primaryBlue};
  `}
  align-items: center;
  border-radius: 0.8rem;
  box-shadow: 0px 10px 20px rgba(48, 52, 92, 0.19);
  cursor: pointer;
  display: flex;
  height: 5rem;
  justify-content: center;
  margin-top: 4.4rem;
  width: 7.2rem;
  h1 {
    ${({ theme }) => `
    color: ${theme.colors.white};
  `}
  }
`;
